import React from 'react';
import { FadeIn } from './FadeIn';
import { CountdownTimer } from './CountdownTimer';
export function OfferSection() {
  const checkoutUrl = 'https://pay.hotmart.com/H104825392W?off=a2wkwelk&checkoutMode=10';
  return <section id="oferta" className="py-16 md:py-24 px-4 bg-gradient-to-b from-orange-warm/10 to-cream" data-id="element-284">
      <div className="max-w-4xl mx-auto" data-id="element-285">
        <FadeIn data-id="element-286">
          <div className="bg-white rounded-3xl shadow-xl border-2 border-orange-warm/30 overflow-hidden" data-id="element-287">
            {/* Header */}
            <div className="bg-green-deep text-white p-6 md:p-8 text-center relative overflow-hidden" data-id="element-288">
              <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-289"></div>
              <h2 className="font-heading font-bold text-3xl md:text-4xl relative z-10 mb-2" data-id="element-290">
                📦 LO QUE RECIBÍS HOY
              </h2>
            </div>

            <div className="p-6 md:p-10" data-id="element-291">
              {/* Image & Stack */}
              <div className="flex flex-col md:flex-row gap-8 items-center mb-10" data-id="element-292">
                <div className="w-full md:w-1/3 shrink-0" data-id="element-293">
                  <img src="https://cdn.magicpatterns.com/uploads/rzcGwWD84Gh6ZaFZeZT5Q2/libroinmunidadtotal.png" alt="Libro Inmunidad Total" className="w-full max-w-[200px] mx-auto drop-shadow-xl rounded-lg" data-id="element-294" />
                </div>

                <div className="w-full md:w-2/3 space-y-4" data-id="element-295">
                  <div className="flex items-start gap-3 pb-4 border-b border-gray-100" data-id="element-296">
                    <span className="text-2xl shrink-0" data-id="element-297">🛡️</span>
                    <div data-id="element-298">
                      <h4 className="font-bold text-text-main" data-id="element-299">
                        Guía Completa INMUNIDAD TOTAL
                      </h4>
                      <p className="text-sm text-text-main/60" data-id="element-300">
                        9 Capítulos · 15 Recetas · Calendario
                      </p>
                    </div>
                    <span className="ml-auto text-sm text-text-main/40 line-through shrink-0" data-id="element-301">
                      Valor: $99
                    </span>
                  </div>

                  <div className="flex items-start gap-3 pb-4 border-b border-gray-100" data-id="element-302">
                    <span className="text-2xl shrink-0" data-id="element-303">⚡</span>
                    <div data-id="element-304">
                      <h4 className="font-bold text-text-main" data-id="element-305">
                        Protocolo SOS — Acceso Rápido
                      </h4>
                      <p className="text-sm text-text-main/60" data-id="element-306">
                        Las primeras 2 horas en PDF
                      </p>
                    </div>
                    <span className="ml-auto text-sm text-text-main/40 line-through shrink-0" data-id="element-307">
                      Valor: $27
                    </span>
                  </div>

                  <div className="flex items-start gap-3 pb-4 border-b border-gray-100" data-id="element-308">
                    <span className="text-2xl shrink-0" data-id="element-309">🧺</span>
                    <div data-id="element-310">
                      <h4 className="font-bold text-text-main" data-id="element-311">
                        Checklist Kit de Emergencia
                      </h4>
                      <p className="text-sm text-text-main/60" data-id="element-312">
                        Lo que siempre debe estar en casa
                      </p>
                    </div>
                    <span className="ml-auto text-sm text-text-main/40 line-through shrink-0" data-id="element-313">
                      Valor: $17
                    </span>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-314">
                    <span className="text-2xl shrink-0" data-id="element-315">🗓️</span>
                    <div data-id="element-316">
                      <h4 className="font-bold text-text-main" data-id="element-317">
                        Calendario Inmunológico Anual
                      </h4>
                      <p className="text-sm text-text-main/60" data-id="element-318">
                        Mes a mes, acciones concretas
                      </p>
                    </div>
                    <span className="ml-auto text-sm text-text-main/40 line-through shrink-0" data-id="element-319">
                      Valor: $19
                    </span>
                  </div>
                </div>
              </div>

              {/* Pricing */}
              <div className="bg-cream rounded-2xl p-6 md:p-8 text-center mb-8 border border-orange-warm/20" data-id="element-320">
                <div className="flex justify-center gap-4 text-text-main/60 mb-2 text-sm md:text-base" data-id="element-321">
                  <span data-id="element-322">
                    VALOR TOTAL: <span className="line-through" data-id="element-323">$162</span>
                  </span>
                  <span data-id="element-324">
                    PRECIO REGULAR: <span className="line-through" data-id="element-325">$99</span>
                  </span>
                </div>

                <div className="inline-block bg-red-alert text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide mb-4" data-id="element-326">
                  AHORRÁS $62 HOY
                </div>

                <div className="font-heading font-bold text-6xl md:text-7xl text-green-deep mb-4" data-id="element-327">
                  $37
                </div>

                <CountdownTimer className="mb-2" data-id="element-328" />
              </div>

              {/* CTA */}
              <a href={checkoutUrl} className="block w-full bg-green-lime text-white text-center font-bold text-lg md:text-xl py-5 px-8 rounded-xl shadow-glow hover:scale-[1.02] transition-transform duration-300 animate-pulse-slow" data-id="element-329">
                🛡️ SÍ, QUIERO INMUNIDAD TOTAL
                <br data-id="element-330" />
                <span className="text-sm md:text-base font-normal opacity-90" data-id="element-331">
                  ACCEDER AHORA POR $37
                </span>
              </a>

              <div className="text-center mt-4 text-sm text-text-main/60 flex items-center justify-center gap-2 flex-wrap" data-id="element-332">
                <span data-id="element-333">🔒 Pago seguro</span>
                <span className="hidden md:inline" data-id="element-334">·</span>
                <span data-id="element-335">⚡ Acceso inmediato</span>
                <span className="hidden md:inline" data-id="element-336">·</span>
                <span data-id="element-337">🛡️ Garantía 30 días</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}